import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./components/Header";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Residency from "./pages/Residency";
import Terapeutas from "./pages/Terapeutas";
import TherapistProfile from "./pages/TherapistProfile";
import SoyTerapeuta from "./pages/SoyTerapeuta";


import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import OAuthConsent from "./pages/OAuthConsent";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";
import BusinessDashboard from "./pages/BusinessDashboard";
import RequireRole from "./components/RequireRole";

const queryClient = new QueryClient();

const App = () => {
  const { t } = useTranslation();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ErrorBoundary
          fallbackTitle={t("errors.boundaryTitle")}
          fallbackText={t("errors.boundaryText")}
          retryLabel={t("errors.retry")}
        >
          <div className="overflow-x-hidden w-full">
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/terapeutas" element={<Terapeutas />} />
                <Route path="/terapeutas/:id" element={<TherapistProfile />} />
                <Route path="/soy-terapeuta" element={<SoyTerapeuta />} />

                <Route path="/retiro" element={<Residency />} />
                <Route path="/residency" element={<Navigate to="/retiro" replace />} />

                <Route path="/terminos" element={<TermsAndConditions />} />
                <Route path="/privacidad" element={<PrivacyPolicy />} />
                <Route path="/acceso" element={<Auth />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/admin" element={<RequireRole rol="admin"><Admin /></RequireRole>} />
                <Route path="/negocio" element={<RequireRole rol="terapeuta"><BusinessDashboard /></RequireRole>} />
                <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </div>
        </ErrorBoundary>
      </TooltipProvider>
    </QueryClientProvider>
  );
};


export default App;
